// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar[data-v-3e810e2c]{border:3px solid #fff!important}.avatar i[data-v-3e810e2c]{font-size:1.4em!important}.avatar[data-v-3e810e2c]:hover{cursor:pointer}.avatar .initials[data-v-3e810e2c]{font-size:1.5rem}", ""]);
// Exports
module.exports = exports;
